import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './styles/globals/colors.css';
import './styles/pages/general.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import SessionExpiryModal from './components/SessionExpiryModal';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import SelectCompanyPage from './pages/SelectCompanyPage';
import DashboardPage from './pages/DashboardPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PagoPubPage from './pages/PagoPubPage';
import PagoPreviredPubPage from './pages/PagoPreviredPubPage';
import IngresoManual from './pages/IngresoManual';
import AsientosContables from './pages/AsientosContables';
import CargaCompras from './pages/CargaCompras';
import CargaVentas from './pages/CargaVentas';
import Balance from './pages/Balance';
import Mayor from './pages/Mayor';
import VerBalance from './pages/VerBalance';
import CargarImagen from './pages/CargarImagen';
import CargarBoletaSII from './pages/CargaBoleElecSII';
import CargaComprobante from './pages/ComprobantePago';
import GastosPendientes from './pages/VerGastosPendientes';
import BoletasHonorarios from './pages/CargarBoletasHonorarios';
import HonorariosPendientes from './pages/VerHonorariosPendientes';
import ServiciosSII from './components/ServiciosSII';
import DeclaracionIva from './components/Servicios_SII/DeclaracionIVA';
import DeclaracionRentaPage from './pages/ServiciosSII/DeclaracionRentaPage';
import DeclaracionesJuradasPage from './pages/ServiciosSII/DeclaracionesJuradasPage';
import CargaSueldos from './pages/CargaSueldos';
import CargaArriendos from './pages/CargaArriendos';
import ManageUsersPage from './pages/ManageUsersPage';
import ManageClientsPage from './pages/ManageClientsPage';
import ManagePaymentsPage from './pages/ManagePaymentsPage';
import ControlClientesPage from './pages/ControlClientesPage';
import NotificacionesPage from './pages/NotificacionesPage';
import CreateCompanyPage from './pages/CreateCompanyPage';
import CompanySettingsPage from './pages/CompanySettingsPage';
import CierreMensual from './pages/CierreMensual';
import CierreAnual from './pages/CierreAnual';

// Módulo de Recursos Humanos
import RRHHPage from './pages/RRHH/RRHHPage';
import ColaboradoresPage from './pages/RRHH/ColaboradoresPage';
import ParametrosEmpresaPage from './pages/RRHH/ParametrosEmpresaPage';
import LiquidacionesPage from './pages/RRHH/LiquidacionesPage';
import PreviredPage from './pages/RRHH/PreviredPage';
import ContratosPage from './pages/RRHH/ContratosPage';
import FiniquitosPage from './pages/RRHH/FiniquitosPage';
import LicenciasMedicasPage from './pages/RRHH/LicenciasMedicasPage';
import IndicadoresPreviredPage from './pages/RRHH/IndicadoresPreviredPage';
import RetencionHonorariosPage from './pages/RRHH/RetencionHonorariosPage';
import DTPage from './pages/RRHH/DTPage';

// Módulo de Arriendos (independiente)
import ArriendosPage from './pages/ArriendosPage';

// Módulo de Patentes Municipales
import PatentesPage from './pages/PatentesPage';

// Socios empresa y Dividendos
import SociosDividendosPage from './pages/SociosDividendosPage';

// Configuración de Medios de Pago
import CredencialesMediosPagoPage from './pages/CredencialesMediosPagoPage';

// Libros Contables SII
import LibroCajaPage from './pages/LibroCajaPage';
import LibroIngresosEgresosPage from './pages/LibroIngresosEgresosPage';

// Acciones Rápidas
import AccionesRapidasPage from './pages/AccionesRapidasPage';

// Solicitudes de Clientes (dashboard contador)
import SolicitudesPage from './pages/SolicitudesPage';

// Módulo de Conciliación Bancaria
import ConciliacionBancariaHub from './pages/ConciliacionBancaria/ConciliacionBancariaHub';
import CuentasBancoPage from './pages/ConciliacionBancaria/CuentasBancoPage';
import CartolasPage from './pages/ConciliacionBancaria/CartolasPage';
import ConciliarPage from './pages/ConciliacionBancaria/ConciliarPage';

// Componente interno que usa el contexto de autenticación
function AppRoutes() {
  const { token, selectedCompany, setToken, setCompany } = useAuth();

  return (
    <Routes>
      {/* Rutas públicas de pago (sin autenticación) */}
      <Route path="/pago/:codigo" element={<PagoPubPage />} />
      <Route path="/pago-previred/:codigo" element={<PagoPreviredPubPage />} />

      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/login" element={<LoginPage setToken={setToken} />} />
      <Route path="/admin-login" element={<AdminLoginPage />} />

      {/* Rutas de Admin (usan sesiones, no token) */}
      <Route path="/manage-clients" element={<ManageClientsPage />} />
      <Route path="/admin/clientes" element={<ManageClientsPage />} />
      <Route path="/admin/clientes/:clienteId/pagos" element={<ManagePaymentsPage />} />
      <Route path="/admin/notificaciones" element={<NotificacionesPage />} />

      {/* Ruta legacy de manage-users (con JWT - deprecada) */}
      <Route
        path="/manage-users"
        element={token ? <ManageUsersPage token={token} /> : <Navigate to="/admin-login" />} />

      <Route
        path="/select-company"
        element={token ? <SelectCompanyPage token={token} setCompany={setCompany} /> : <Navigate to="/login" />}
      />
      <Route
        path="/create-company"
        element={token ? <CreateCompanyPage token={token} /> : <Navigate to="/login" />}
      />
      <Route
        path="/dashboard"
        element={token && selectedCompany ? <DashboardPage token={token} company={selectedCompany} /> : <Navigate to="/select-company" />}
      />
      <Route
        path="/configuracion"
        element={token && selectedCompany ? <CompanySettingsPage token={token} id_company={selectedCompany.id_company} setCompany={setCompany} /> : <Navigate to="/select-company" />}
      />
      <Route path="/" element={<Navigate to="/login" />} />


      <Route path="/ingreso-manual" element={token && selectedCompany ? <IngresoManual token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/asientos-contables" element={token && selectedCompany ? <AsientosContables token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      <Route path="/carga-compras" element={token && selectedCompany ? <CargaCompras token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />
      <Route path="/carga-ventas" element={token && selectedCompany ? <CargaVentas token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />
      <Route path="/balance" element={token && selectedCompany ? <Balance token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />
      <Route path="/mayor" element={token && selectedCompany ? <Mayor token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />
      <Route path="/ver-balance" element={token && selectedCompany ? <VerBalance token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />

      <Route path="/cargar-imagen" element={token && selectedCompany ? <CargarImagen token={token} id_company={selectedCompany.id_company} /> : <Navigate to= "/select-company" />} />
      <Route path="/cargar-boletas-sii" element={token && selectedCompany ? <CargarBoletaSII token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company" />} />
      <Route path="/comprobante-pago" element={token && selectedCompany ? <CargaComprobante token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company" />} />
      <Route path="/ver-gastos-pendientes" element={token && selectedCompany ? <GastosPendientes token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company" />} />
      <Route path="/boletas-honorarios" element={token && selectedCompany ? <BoletasHonorarios token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company" />} />
      <Route path="/carga-sueldos" element={token && selectedCompany ? <CargaSueldos token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/carga-arriendos" element={token && selectedCompany ? <CargaArriendos token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/ver-honorarios-pendientes" element={token && selectedCompany ? <HonorariosPendientes token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company" />} />
      <Route path="/servicios-sii" element={token && selectedCompany ?<ServiciosSII token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company"/>} />
      <Route path="/declaracion-iva" element={token && selectedCompany ? <DeclaracionIva token={token} id_company={selectedCompany.id_company} area={selectedCompany.area } /> : <Navigate to= "/select-company"/>} />
      <Route path="/declaraciones-juradas" element={token && selectedCompany ? <DeclaracionesJuradasPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/declaracion-renta" element={token && selectedCompany ? <DeclaracionRentaPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/cierre-mensual" element={token && selectedCompany ? <CierreMensual token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/cierre-anual" element={token && selectedCompany ? <CierreAnual token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Rutas del Módulo de Recursos Humanos */}
      <Route path="/rrhh" element={token && selectedCompany ? <RRHHPage id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/parametros" element={token && selectedCompany ? <ParametrosEmpresaPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/colaboradores" element={token && selectedCompany ? <ColaboradoresPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/liquidaciones" element={token && selectedCompany ? <LiquidacionesPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/previred" element={token && selectedCompany ? <PreviredPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/contratos" element={token && selectedCompany ? <ContratosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/indicadores-previred" element={token && selectedCompany ? <IndicadoresPreviredPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/finiquitos" element={token && selectedCompany ? <FiniquitosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/licencias-medicas" element={token && selectedCompany ? <LicenciasMedicasPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/retencion-honorarios" element={token && selectedCompany ? <RetencionHonorariosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/rrhh/dt" element={token && selectedCompany ? <DTPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Módulo de Arriendos (independiente) */}
      <Route path="/arriendos" element={token && selectedCompany ? <ArriendosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Módulo de Patentes Municipales */}
      <Route path="/patentes" element={token && selectedCompany ? <PatentesPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Socios empresa y Dividendos */}
      <Route path="/socios-dividendos" element={token && selectedCompany ? <SociosDividendosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Configuración de Medios de Pago */}
      <Route path="/credenciales-medios-pago" element={token && selectedCompany ? <CredencialesMediosPagoPage token={token} id_company={selectedCompany.id_company} company={selectedCompany} /> : <Navigate to="/select-company" />} />

      {/* Libros Contables SII */}
      <Route path="/libro-caja" element={token && selectedCompany ? <LibroCajaPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/libro-ingresos-egresos" element={token && selectedCompany ? <LibroIngresosEgresosPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Acciones Rápidas */}
      <Route path="/acciones-rapidas" element={token && selectedCompany ? <AccionesRapidasPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />

      {/* Solicitudes de Clientes — dashboard del contador */}
      <Route path="/solicitudes" element={token ? <SolicitudesPage token={token} /> : <Navigate to="/login" />} />
      <Route path="/control-clientes" element={token ? <ControlClientesPage /> : <Navigate to="/login" />} />

      {/* Módulo de Conciliación Bancaria */}
      <Route path="/conciliacion-bancaria" element={token && selectedCompany ? <ConciliacionBancariaHub /> : <Navigate to="/select-company" />} />
      <Route path="/conciliacion-bancaria/cuentas" element={token && selectedCompany ? <CuentasBancoPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/conciliacion-bancaria/cartolas" element={token && selectedCompany ? <CartolasPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
      <Route path="/conciliacion-bancaria/conciliar" element={token && selectedCompany ? <ConciliarPage token={token} id_company={selectedCompany.id_company} /> : <Navigate to="/select-company" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <SessionExpiryModal />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
